import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
import axios from "axios";
import HandlePaginateService from "@/services/HandlePaginateService";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: "refundHistoryList",
  components: {
    MainLayout,
    Loading,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate
  },

  data() {
      return {
          isFilterOpen: false,
          isLoading: false,
          refundData: { 
            total: 0, 
            list: [], 
            current_page: 1, 
            per_page: 10 
          },
          searchData: {
            period_id: '',
            class_id: '',
            stuName: '',
            p_method: '',
            fromAmt: '',
            toAmt: '',
            startDate: '',
            endDate: ''
          },
          periodArr: [],
          classArr: [],
          paymentMethodArr: [],
          noDataMsg: CONFIG.noDataMsg,
          search_status: false,
          currency_txt: '',
      };
  },
  methods: {
    getPeriods() {
      this.isLoading = true;
      axios.get('period/periodList')
        .then(res => {
          let defaultOption = [{ id: '0', text: 'Select Academic Year' }];
          this.periodArr = defaultOption.concat(res.data.data);
          
          this.isLoading = false;
        })
        .catch(error => this.handleError(error));
    },

    getClass(yearId) {
      this.searchData.class_id = ''; 
      this.classArr = [];

      axios.get("class/classList/" + yearId, {
        params: {
          campus_id: this.$store.state.user.campus_id,
        }
      })
      .then(res => {
        this.classArr = [{ id: '0', text: 'Select Class' }].concat(res.data);
        this.isLoading = false;
      }).catch(err => this.handleError(err))
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
      .then(res => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Payment Method'
        }];
        this.paymentMethodArr = $defaultSelectOption.concat(res.data);
      }).catch(err => this.handleError(err))
    },

    getData(page = 1) {
      this.isLoading = true;
      const params = { ...this.searchData, page: page };

      axios.get('enrollment/refund/history/list', { params })
          .then(res => {
              this.refundData = res.data.data; 
              this.currency_txt = res.data.currency_txt;
              this.isLoading = false;
          })
          .catch(err => {
              this.isLoading = false;
              console.error(err);
          });
    },

    searching() {
        this.isLoading = true;
        this.getData(1);
    },
    reset() {
      this.searchData = {
        period_id: '',
        class_id: '',
        stuName: '',
        p_method: '',
        fromAmt: '',
        toAmt: '',
        startDate: '',
        endDate: ''
      };
      this.search_status = false;
      this.getData(1);
    },
    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.searching,
        listFn: this.getPayment
      })
    },

    showDetail(id) {
      this.$router.push({
        name: 'refundHistoryDetail',
        params: {
          id: id,
        }
      });
    },

    filterRefundAmount(field) {
      let value = this.searchData[field];

      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');

      this.searchData[field] = value ? parseInt(value) : null;
    },

    excelDownload() {
      this.isLoading = true;
      const params = { ...this.searchData };
      
      axios.get('enrollment/refund/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.isLoading = false;
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        fileLink.setAttribute('download', `refund_history_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response && error.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          this.$notification.error("Failed to download Excel file", {
            timer: 3,
            position: "bottomCenter"
          });
          console.error("Excel Download Error:", error);
        }
      });
    },

    handleError(error) {
      if (error.response && error.response.status === 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      } else {
        console.error(error);
      }
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPeriods(); 
    this.getPaymentMethod();
    this.getData(1);
  }
}
